export default __webpack_public_path__ + "static/media/watch-vault-1440.757f8363.svg";